// extracted by mini-css-extract-plugin
export default {"videoSection":"Styles_videoSection__x2snr","notesSection":"Styles_notesSection__N+r6N","fullWidth":"Styles_fullWidth__J+clp","hidden":"Styles_hidden__ZP2fj"};